import { useEffect, useRef } from 'react';
import { useToast } from '../../context/ToastContext';
import { RATE_LIMIT_EVENT } from '../../api';

const MIN_GAP_MS = 15000;

export default function RateLimitNotice() {
  const toast = useToast();
  const lastShownRef = useRef(0);

  useEffect(() => {
    const handler = () => {
      const now = Date.now();
      if (now - lastShownRef.current < MIN_GAP_MS) return;
      lastShownRef.current = now;
      toast?.error("You're making requests too quickly. Some data may be out of date — please wait a moment and try again.");
    };
    window.addEventListener(RATE_LIMIT_EVENT, handler);
    return () => window.removeEventListener(RATE_LIMIT_EVENT, handler);
  }, [toast]);

  return null;
}
